import React, { Component, PropTypes } from 'react'


export default class DashboardWidget extends Component {

  render() {
    return (
      <div className='mini-stat clearfix'>
        <span className={'icon ' + this.props.color}>
          <i className={ this.props.icon }></i>
        </span>
        <div className='info'>
          <span className='title'>{ this.props.title }</span>
          <span>{ this.props.comment }</span>
        </div>
      </div>
    )
  }
}

DashboardWidget.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  color: PropTypes.string.isRequired,
  comment: PropTypes.string.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/DashboardWidget.js
 **/